export const HIDDEN_CATERING_SECTIONS = ['Sign-up & login', 'Actions']
export const HIDDEN_CATERING_CHILDREN = [
  'Questions before selection',
  'Cart minimums',
  'Pricing tiers',
  'Fulfillment methods',
  'Membership tiers'
]

export function buildStoreEditorSections({
  hasAnnouncements = false,
  handle = '',
  isCatering = false,
  canInvoice = false,
  hasMembershipTiers = true
} = {}) {
  const base = [
    {
      name: 'Main info',
      link: 'main',
      children: [
        { name: 'Details', link: 'basics' },
        { name: 'Access', link: 'access' }
      ]
    },
    {
      name: 'Product selection',
      link: 'selection',
      children: [
        { name: 'Store banner', link: 'selection-settings' },
        { name: 'Questions before selection', link: 'questions-before-selection' },
        { name: 'Categories', link: 'categories' },
        { name: 'Upsells', link: 'upsells' },
        { name: 'Cart minimums', link: 'minimums' },
        { name: 'Pricing tiers', link: 'pricing-tiers' },
        { name: 'Discount limit', link: 'discount-limit' },
        { name: 'Packages', link: 'packages' }
      ]
    },
    {
      name: 'Product availability',
      link: 'availability',
      children: [{ name: 'Product availability', link: 'availability' }]
    },
    {
      name: 'Sign-up & login',
      link: 'signup',
      children: [
        { name: 'Sign-up explanation message', link: 'sign-up-explanation' },
        { name: 'New sign-up message automation', link: 'new-sign-up-automation' }
      ]
    },
    ...(hasAnnouncements
      ? [
          {
            name: 'Announcements',
            link: 'announcements',
            children: [{ name: 'Announcement settings', link: 'announcements' }]
          }
        ]
      : []),
    {
      name: 'Checkout',
      link: 'checkout',
      children: [
        { name: 'Questions before checkout', link: 'questions-before-checkout' },
        { name: 'Fulfillment methods', link: 'fulfillment' },
        ...(hasMembershipTiers ? [{ name: 'Membership tiers', link: 'membership-tiers' }] : []),
        { name: 'Tipping', link: 'tipping' },
        ...(canInvoice ? [{ name: 'Invoice only', link: 'invoicing' }] : []),
        { name: 'Taxes', link: 'taxes' },
        { name: `Additional ${handle} fee`, link: 'merchant-fee' },
        { name: 'Bottle fees', link: 'bottle-fees' }
      ]
    },
    {
      name: 'Receipt',
      link: 'receipt',
      children: [
        { name: 'Receipt page settings', link: 'receipt-settings' },
        { name: 'Paid order message automation', link: 'paid-bottle-automation' },
        { name: 'Questions on receipt', link: 'questions-after-checkout' }
      ]
    },
    {
      name: 'Actions',
      link: 'actions',
      children: [{ name: 'Actions', link: 'actions' }]
    }
  ]

  if (!isCatering) return base
  return base
    .filter(section => !HIDDEN_CATERING_SECTIONS.includes(section.name))
    .map(section => ({
      ...section,
      children: section.children.filter(child => !HIDDEN_CATERING_CHILDREN.includes(child.name))
    }))
}

export function resolveStoreTab(sections = [], requested) {
  const ids = sections.map(section => section.link)
  return ids.includes(requested) ? requested : ids[0]
}

export function storeTabPath(storeId, tabId) {
  return `/store/stores/${storeId}/${tabId}`
}

export function storeTabForAnchor(sections = [], anchor) {
  return sections.find(section => section.link === anchor || section.children?.some(child => child.link === anchor))
    ?.link
}

export function sectionFor(sections = [], tabId) {
  return sections.find(section => section.link === tabId)
}

export function buildStoreTabs({ sections = [], storeId, activeTab } = {}) {
  return sections.map(section => ({
    id: section.link,
    name: section.name,
    to: storeTabPath(storeId, section.link),
    active: activeTab === section.link
  }))
}
